import { ICartRowItem } from "../../../Cart/types/ICartRowItem";

export class ItemRowModel {

    public PopupImage: KnockoutObservable<string> = ko.observable('imagenotavailable.jpg');
    public LoadPopupImage = (data) => {
        console.debug("LoadPopupImage: ", { data });
        if (!data) {
            return this.PopupImage('imagenotavailable.jpg');
        }
        if (typeof data == 'string') {
            this.PopupImage(data);
        } else {
            if (data.ItemImagePrimary) {
                let popupImage = document.getElementById('popup-image');
                if (data.ItemAltText) {
                    popupImage.setAttribute("alt", data.ItemAltText);
                }
                else if (data.Description) {
                    popupImage.setAttribute("alt", data.Description);
                }

                if (data.SDname) {
                    popupImage.setAttribute("title", data.SDname);
                } else if (data.Description){
                    popupImage.setAttribute("title", data.Description);
                }
                this.PopupImage(data.ItemImagePrimary);
            }
            else {
                return this.PopupImage('imagenotavailable.jpg');
            }
        }
    }

    public QtyOrdered = (data: ICartRowItem) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return 0;
                if (data.QtyOrdered != null)
                    return data.QtyOrdered;
                else
                    return 0;
            }
        }, this);
    }

    public AddToContract = (data: ICartRowItem) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return 0;
                if (data.AddToContract != null)
                    return data.AddToContract;
                else
                    return "";
            }
        }, this);
    }

    public OnSale = (data: ICartRowItem) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return 0;
                if (data.OnSale != null)
                    return data.OnSale;
                else
                    return "";
            }
        }, this);
    }

    public OnContract = (data: ICartRowItem) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return 0;
                if (data.OnContract != null)
                    return data.OnContract;
                else
                    return false;
            }
        }, this);
    }

   
    public StockStatus = (data: ICartRowItem) => // Add popover stock status
    {
        if (!data) {
            return;
        }
        let alertStatus = "", alertExpStatus = "";
        if (data.ALERTStatus !== null) {
            let tmpdata = data.ALERTStatus.replace(/"/g, "&quot;");
            alertStatus = tmpdata.replace(/'/g, "&#39;");
        }
        if (data.ALERTExpStatus !== null) {
            let tmpdata = data.ALERTExpStatus.replace(/"/g, "&quot;");
            alertExpStatus = tmpdata.replace(/'/g, "&#39;");
        }        
        let htmlShipping =
            `<div class='d-flex flex-column justify-content-between'><strong class='pr-1 pb-1'>Est. Ship Date:</strong>` + data.INFOEstShipDate + `</div>`;
        let htmlBackorder =
            `<div class='d-flex flex-column'>
                    <div class='d-flex flex-column justify-content-between'><strong class='pr-1 pb-1'>Backorder Status:</strong>`
            + alertStatus + `</div>
                    <div class='d-flex flex-row justify-content-between'><strong class='pr-1 pb-1'>Origination Date:</strong>` + data.ALERTOrgDate + `</div>
                    <div class='d-flex flex-row justify-content-between'><strong class='pr-2 pb-1'>Last Updated:</strong>` + data.ALERTUpdateDate + `</div>
                    </div>`;
        let htmlExpiring =
            `
                    <div class='d-flex flex-column justify-content-between'><strong class='pr-1 pb-1'>Please Note:</strong>`
            + alertExpStatus + `</div>
                    `;
        let alertString = "";
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return;

                switch (data.Status) {                    
                    case 'IN STOCK':
                        return '<i class="text-success fas fa-check-circle" data-toggle="tooltip" title="Item is in stock"></i>&nbsp;<span class="tw-text-[12px]">In Stock</span>';
                    case 'ALERT':
                        if (data.AlertType === "Expiring")
                        {
                            alertString = htmlExpiring;
                            return '<i class="fas fa-hourglass-half" data-toggle="tooltip" data-html="true" title="' + alertString + '"></i>';
                        } 
                        if (data.AlertType === "Backorder")
                            alertString = htmlBackorder;
                        if (data.AlertType === "Allocation")
                        {
                            alertString = htmlBackorder;                            
                            return '<i class="text-danger fa fa-bullhorn" data-toggle="tooltip" data-html="true" title="' + alertString + '"></i>';
                        } 
                        return '<i class="text-danger fas fa-exclamation-triangle" data-toggle="tooltip" data-html="true" title="' + alertString + '"></i>';
                    case 'INFO':
                        return '<i class="text-warning fas fa-info-circle" data-toggle="tooltip" data-html="true" title="' + htmlShipping + '"></i>';                                            
                    case 'DIRECTSHIP':
                        return '<i class="text-info fas fa-exclamation-triangle" data-toggle="tooltip" title="Ships direct from supplier"></i>';
                }
            }
        }, this);
    }
    public IsRx = (data: ICartRowItem) => {
        return ko.computed({
            owner: this,
            read: () => {
                if (!data)
                    return;
                if (data.Rx)
                    return '<i class="fas fa-prescription"></i>';
            }
        }, this);
    }

    public GetSelectionQty = (data, context) => {
        if (!data || !context)
            return;
        context.UMQtySelected(data.UMQty);
        context.UoMSelected(data.UoM);
        context.Quantity(data.QtySelected());
        context.Quantity.setOriginalValue(data.QtySelected());
    }

    public MatchUMQty = (umqty, item) => {
        if (!umqty || !item)
            return;
        $.each(item.UoMPrices(), (index, uom) => {
            // Find UoM Qty match
            if (uom.UMQty === umqty) {
                item.Quantity(uom.QtySelected())
            }
        })

    }
    public UpdateQty = (data: any, event) => {
        let button = $(event.currentTarget);
        let input = $(button).parent().parent().find('input[name=Quantity]');
        let btn = "";
        if ($(input).attr("shopCart") == "1") {
            let btn = ($(button).attr("id")).replace("2-", "-").replace("1-", "-");
            btn = btn.replace("add-to-cart-btn-", "quantity-field-");
            btn = $("#" + btn).attr("old-value");
        }
        let baseValue = (btn > "") ? btn : $("#" + $(input).attr("id").replace("add-to-cart-btn-", "quantity-field-")).attr("old-value");
        let qty: KnockoutObservable<any>;
        qty = (data.Quantity) ? (data.Quantity) : data.QuantityOrdered
        var currentValue = parseInt(input.val().toString());
        var maxValue = parseInt(input.attr('max'));
        var minValue = parseInt(input.attr('min'));
        var newValue = currentValue;
        console.log("UpdateQty values: ", { data, event, qty, currentValue });
        if (button.data('action') === 'increment') {
            newValue++;
            newValue = (newValue <= maxValue) ? newValue : currentValue;
        }
        else if (button.data('action') === 'decrement') {
            newValue--;
            newValue = (newValue > minValue) ? newValue : 0;
        }
        data.QuantityOrdered = newValue;
        if (newValue != parseInt(baseValue)) {
            data.QuantityOrdered = newValue;
            data.QtyOrdered = newValue;
        } 
        qty(newValue);
        
        if($('#items-repeater').children().length <= 2 && newValue == 0){
          // No items left in cart
          let link = $('<a>our product categories.</a>').attr({
              'href': '/products/',
              'style': 'text-decoration:underline'
            }),
              msg = $('<span>Cart is empty. Start browsing </span>').append(link);

            $('#empty-cart-alert').empty().append(msg);
            $('#active-cart').hide();

            $('#cart-order-number').text('');
            $('#cart-order-number-label').hide();
            localStorage.removeItem("CartSessionKey");
        }

        console.log(button.data('action') + data.ItemID, { data, currentValue, baseValue, newValue, qty })
    }
}